import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type ConfirmModalProps = {
    open: boolean;
    title: string;
    message: string | React.ReactNode;
    onCancel: () => void;
    onConfirm: () => void;
    onClose?: () => void;
    cancelLabel?: string;
    confirmLabel?: string;
    confirmColor?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
};

export default function ConfirmModal({
    open,
    title,
    message,
    onCancel,
    onConfirm,
    onClose,
    cancelLabel = "Cancel",
    confirmLabel = "Continue",
    confirmColor = "warning"
}: ConfirmModalProps) {
    return (
        <Dialog open={open} onClose={onClose || onCancel} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {title}
                <IconButton
                    aria-label="close"
                    onClick={onClose || onCancel}
                    sx={{
                        p:0, color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button onClick={onCancel} variant="outlined" color="inherit">
                    {cancelLabel}
                </Button>
                <Button onClick={onConfirm} variant="contained" color={confirmColor}>
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
